import style from 'providers/style';

const styles = (theme) => ({
  iconClass: {
    background: 'transparent',
    '&:hover': {
      background: 'transparent !important',
    },
    '&:focus': {
      background: 'transparent !important',
    },
    '&:active': {
      background: 'transparent !important',
    },
    composes: 'cypress-drop-down-menu',
  },
  mobileProfile: {
    color: theme.palette.grey[900],
  },
  active: {
    position: 'relative',
    color: `${theme.palette.primary.main} !important`,
    '&::before': {
      content: '" "',
      position: 'absolute',
      bottom: -theme.spacing(2),
      left: 0,
      right: 0,
      margin: '0 auto',
      width: '100%',
      height: theme.spacing(1) / 4,
      backgroundColor: theme.palette.primary.main,
    },
  },
  bar: {
    width: '100%',
    height: 64,
    backgroundColor: 'rgba(255, 255, 255, 1)',
    boxShadow: 'none',
    borderBottom: '1px solid #ececec',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  container: {
    maxWidth: 1280,
    margin: '0 auto',
  },
  appBarLogo: {
    width: 'calc(36px + 24px)',
    height: 36,
    marginRight: 14,
    // borderRight: '1px solid rgba(238, 243, 247, 1)',
    margin: '0 14px',
  },
  headerNavShow: {
    '&.true': {
      height: 'auto',
      display: 'flex !important',
      position: 'relative',
    },
  },
  openSubmenuItem: {
    '&.true': {
      height: '100% !important',
    },
  },
  appBarMenu: {
    margin: '0',
    padding: '0',
    display: 'flex',
    alignItems: 'center',
    color: 'rgba(123, 128, 133, 1)',
    height: '100%',
  },
  appBarMenuItem: {
    listStyle: 'none',
    height: '100%',
    marginRight: '24px',
    fontSize: '14px',
    '& a': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    '& span': {
      marginRight: theme.spacing(1),
    },
  },
  link: {
    height: '100%',
    display: 'flex',
  },
  iconUserMobile: {
    display: 'none',
  },
  userNameProfile: {
    '& a': {
      '& p': {
        fontSize: '0.8em',
      },
    },
  },
  header_nav_hemberger: {
    display: 'none',
    zIndex: 20,
    position: 'relative',
    transform: 'rotate(0deg)',
    transition: '0.5s ease-in-out',
    cursor: 'pointer',
    height: '25px',
    width: '24px',
    '& span': {
      display: 'block',
      position: 'absolute',
      height: '2px',
      width: '100%',
      background: '#000',
      opacity: 1,
      left: 0,
      transform: 'rotate(0deg)',
      transition: '0.30s ease-in-out',
      borderRadius: '5px',
      '&:nth-child(1)': {
        top: '4px',
      },
      '&:nth-child(2)': {
        top: '10px',
      },
      '&:nth-child(3)': {
        top: '16px',
        width: '70%',
        right: '0',
      },
    },
  },
  open: {
    '& span': {
      '&:nth-child(1)': {
        top: '12px',
        transform: 'rotate(135deg)',
        background: '#fff',
      },
      '&:nth-child(2)': {
        opacity: 0,
        left: '60px',
        background: '#fff',
        transition: '0.1s ease-in-out',
      },
      '&:nth-child(3)': {
        top: '12px',
        transform: 'rotate(-135deg)',
        width: '100%',
        background: '#fff',
      },
    },
  },
  loginUser: {
    borderRadius: 40,
    backgroundColor: '#2d3ab5',
    padding: 10,
    textAlign: 'center',
    width: '100%',
    '& span,i': {
      color: '#fff',
    },
    '& span': {
      marginLeft: 10,
    },
  },

  '@media screen and (max-width: 480px)': {
    loginUser: {
      '& .login-text': {
        display: 'none',
      },
      width: 40,
      height: 40,
      borderRadius: 5,
      marginLeft: 0,
      marginRight: 0,
      '& a': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& span': {
          display: 'none',
        },
        '& i': {
          margin: 0,
        },
      },
    },
  },
  '@media screen and (max-width: 1024px)': {
    header_nav_hemberger: {
      display: 'block !important',
    },
    menu: {
      order: 1,
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
    logobar: {
      order: 2,
      justifyContent: 'center',
    },
    userProfile: {
      order: 3,
    },
    mobileProfile: {
      display: 'none',
    },
    appBartitle: {
      display: 'none',
    },
    iconUserMobile: {
      display: 'block',
    },
    appBarMenu: {
      position: 'fixed',
      width: '100%',
      top: 0,
      height: '100%',
      left: 0,
      background: 'rgba(0,0,0,1)',
      zIndex: 5,
      transform: 'translateX(-100%)',
      transition: 'all 0.6s cubic-bezier(0.77, 0, 0.175, 1)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      paddingTop: '4em',
      paddingLeft: '1em',
      '& li': {
        height: '3em',
      },
    },
    active: {
      '&::before': {
        display: 'none',
      },
    },
    header__menu__show: {
      transform: 'translateX(0)',
    },
  },
});

export default style(styles);
